import { render, staticRenderFns } from "./AwardsTable.vue?vue&type=template&id=686ab736&scoped=true&"
import script from "./AwardsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardsTable.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardsTable.vue?vue&type=style&index=0&id=686ab736&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686ab736",
  null
  
)

export default component.exports